import React from 'react';
import { Field } from 'formik';

import Select from 'components/common/form/Select';
import { USER_ITEM_STATUSES } from 'constants/userStatuses';

const UserItemStatusFilter = () => (
    <Field
        name='status'
        component={Select}
        placeholder='Все'
        allowClear={true}
        options={USER_ITEM_STATUSES}
        path='type' />
);

export default UserItemStatusFilter;
